import { LogMessageDataType } from './LogMessageDataType';
export class Log {
    /**
     * The markdown shortcode for resource data, e.g. `:p:megacredits:`, for plain-text logs.
     * Returns undefined for other data.
     */
    static shortcode(datum) {
        switch (datum.type) {
            case LogMessageDataType.RESOURCE:
                return `:r:${datum.value}:`;
            case LogMessageDataType.PRODUCTION:
                return `:p:${datum.value}:`;
            case LogMessageDataType.CARD_RESOURCE:
                return `:cr:${datum.value.toLowerCase().replaceAll(' ', '-')}:`;
            default:
                return undefined;
        }
    }
    static applyData(message, cb) {
        return message.message.replace(/\$\{(\d{1,2})\}/gi, (_match, idx) => {
            return cb(message.data[idx], idx);
        });
    }
    static parse(message) {
        // Regex that captures the placeholder strings like '${0}'
        const regex = /(\$\{\d+\})/g;
        const parsedArray = message.message.split(regex).filter(Boolean);
        return parsedArray.map((item) => {
            if (item.startsWith('${') && item.endsWith('}')) {
                const idx = Number(item.substring(2, item.length - 1));
                return message.data[idx];
            }
            return item;
        });
    }
}
